import React from 'react';
import './RoundCheckbox.css';
import tr from '../../../libs/tr'

class RoundCheckbox extends React.Component {
  constructor(props) {
    super();
    //console.log("props: ", props);

    this.state = {
      rCheckbox: false,
      checkText: props.checkText,
    };

    this.phoneView = props.phoneView ? props.phoneView : false;
  };

  activeButton = () => {
    this.setState({ rCheckbox: !this.state.rCheckbox })
    // this.props.controller(this.state.rCheckbox);
  }


  render() {
    return (
      <div>
        {
          <div className="row">
            <div className="col-12">
              <div className="sn_cbox">
                <label className={this.props.isChecked ? 'radioBold' : ''} onChange={this.activeButton}>
                  <span className="spaceIn">{this.state.checkText}</span>
                  <input name={this.props.index} id={this.props.index} type="checkbox" onClick={(e) =>{this.props.onClick(e)}} />
                  <span className="rCheckmark"></span>
                </label>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default RoundCheckbox;



// WEBPACK FOOTER //
// ./src/assets/components/checkbox/RoundCheckbox.js